import React from 'react';
import '../styles/ActivitiesPage.css';
import ActivityCard from './ActivityCard';

const ActivitiesPage = () => {
  const activities = [
    {
      id: 1,
      title: 'Scuba Diving',
      description: 'Explore vibrant coral reefs and encounter exotic marine life in the crystal-clear waters around Kadmat Island. Our certified instructors ensure a safe and unforgettable underwater adventure for all skill levels.',
      image: '/images/scuba-diving.jpg', // You'll need to add these images to your public folder
    },
    {
      id: 2,
      title: 'Snorkelling',
      description: 'Discover the colorful underwater world just below the surface. Our guided snorkeling tours take you to the best spots to observe tropical fish and coral formations in their natural habitat.',
      image: '/images/snorkelling.jpg',
    },
    {
      id: 3,
      title: 'Beach Activities',
      description: 'Relax on pristine white sand beaches, enjoy beachside picnics, or try your hand at beach volleyball and other games. Our beaches offer the perfect setting for both relaxation and recreation.',
      image: '/images/beach-activities.jpg',
    },
    {
      id: 4,
      title: 'Water Sports',
      description: 'Experience the thrill of jet skiing, parasailing, windsurfing, and kayaking in the turquoise waters of the bay. Our experienced staff provide all necessary equipment and guidance.',
      image: '/images/water-sports.jpg',
    },
    {
      id: 5,
      title: 'Glass Bottom Boats',
      description: 'Take a ride on our glass bottom boats to observe the marine ecosystem without getting wet. Perfect for families and those who prefer to stay dry while still experiencing the underwater beauty.',
      image: '/images/glass-bottom-boat.jpg',
    },
    {
      id: 6,
      title: 'Island Trails',
      description: 'Explore the natural beauty of Kadmat Island through guided hiking trails. Discover lush vegetation, spot local wildlife, and enjoy breathtaking views of the surrounding ocean.',
      image: '/images/island-trails.jpg',
    },
  ];

  return (
    <div className="activities-page">
      <div className="about-content-wrapper">
        <div className="activities-hero">
          <div className="activities-title">
            <h1>Activities</h1>
          </div>
        
        <div className="activities-description">
          <p>
            At Turtles Bay, there's something for every type of traveler. Dive into vibrant coral reefs, kayak across
            crystal-clear lagoons, or simply relax on the pristine beaches. Explore Kadmat Island's natural beauty with
            island trails, and unforgettable wildlife encounters. Whether you seek adventure or relaxation, we have the
            perfect experience waiting for you.
          </p>
          <div className="divider"></div>
        </div>
        <div className="activities-grid">
          {activities.map((activity) => (
            <ActivityCard
              key={activity.id}
              title={activity.title}
              description={activity.description}
              image={activity.image}
            />
          ))}
        </div>
      </div>
    </div>
    </div>
  );
};

export default ActivitiesPage;


